import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import Order from "../../models/order/order.model";

export type AdminOrder = Order & { _docId?: string };

interface OrderStateType {
    isLoading: boolean
    orders: Order[]
    createOrderSuccess: boolean
    updateOrderSuccess: boolean
    error: string
    adminOrders: AdminOrder[]
    adminOrdersLoading: boolean
    adminOrdersError: string
}

const initialState: OrderStateType = {
    isLoading: false,
    orders: [],
    createOrderSuccess: false,
    updateOrderSuccess: false,
    error: "",
    adminOrders: [],
    adminOrdersLoading: false,
    adminOrdersError: "",
};

export const OrderSlice = createSlice({
    name: "Order",
    initialState: initialState,
    reducers: {
        setIsLoading: (state) => {
            state.isLoading = true;
        },
        getOrdersSuccess: (state, action: PayloadAction<Order[]>) => {
            state.isLoading = false;
            state.orders = action.payload;
        },
        createOrderSuccess: (state) => {
            state.isLoading = false;
            state.createOrderSuccess = true;
        },
        updateOrderSuccess: (state, action: PayloadAction<Order[]>) => {
            state.isLoading = false;
            state.updateOrderSuccess = true;
            state.orders = action.payload;
        },
        setError: (state, action: PayloadAction<string>) => {
            state.isLoading = false;
            state.error = action.payload;
        },
        setAdminOrdersLoading: (state) => {
            state.adminOrdersLoading = true;
            state.adminOrdersError = "";
        },
        setAdminOrdersSuccess: (state, action: PayloadAction<AdminOrder[]>) => {
            state.adminOrdersLoading = false;
            state.adminOrders = action.payload;
        },
        setAdminOrdersError: (state, action: PayloadAction<string>) => {
            state.adminOrdersLoading = false;
            state.adminOrdersError = action.payload;
        },
        clearState: (state) => {
            state.isLoading = false;
            state.createOrderSuccess = false;
            state.updateOrderSuccess = false;
            state.error = "";
        }
    }
});

export default OrderSlice.reducer;
export const {
    setIsLoading,
    getOrdersSuccess,
    createOrderSuccess,
    updateOrderSuccess,
    setError,
    setAdminOrdersLoading,
    setAdminOrdersSuccess,
    setAdminOrdersError,
    clearState
} = OrderSlice.actions;